define([
    "jquery",
    "underscore",
    "marionette",
    "forms/platform/fix_api_form",
    "behaviors/form_errors_behavior",
    "backbone.syphon",
    "holdon"
], function($, _, Marionette, Form, FormErrorsBehavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        ui:{
            'submitBtn': '.ct_btn8',
            'form': '#fix_api_form'
        },

        events:{
            'click @ui.submitBtn': 'submit'
        },

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        initialize: function(){
            this.bindUIElements();
            
            this.form = new Form();
        },
                
        submit: function(e){
            var that = this;
            if(e) e.preventDefault();

            var formData = Backbone.Syphon.serialize(this);

            this.form.set(formData);

            var errors = this.form.validate();

            if(_.size(errors) < 1){
                HoldOn.open({
                    theme:"sk-fading-circle"
                });
                this.form.validateWithServer({
                    type: 'POST',
                    success: function(model, res){
                        that.ui.form.submit();
                    },
                    error: function(model, error){
                        that.triggerMethod('show:errors', error.responseJSON);
                        HoldOn.close();
                    }
                });
            }else{
                this.triggerMethod('show:errors', errors);
            }
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./assets/uk/main/js/views/w/platform/fix_api_view.js
// module id = 62
// module chunks = 0